// extracted by mini-css-extract-plugin
export default {"page":"Servicios_page__79fD9","footer":"Servicios_footer__nbVxU"};